export const bovineObj = {
  transaction_id: "",
  body_number: 0,
  lot_no: 0,
  lot_size: 1,
  owner: "",
  origin: "",
  rfid_no: "",
  nlis_id: null,
  hscw: null,
  sex: null,
  dentition: null,
  category: null,
  fat_depth: null,
  bruising_l: null,
  bruising_r: null,
  carcase_condemn: null,
  condemn_area: null,
  condemn_info: null,
  MSA: 0,
  HGP: null,
  TS: "",
  production_date: null,
  process_time: null,
  scan_time: null,
  grade_time: null,
  chill_start_time: null,
  chill_stop_time: null,
  upload_time: null,
  invoice_no: null,
  PIC: "",
};
export const ovineObj = {
  transaction_id: "",
  body_number: 0,
  lot_no: 0,
  lot_size: 1,
  mob_no: null,
  owner: "",
  origin: "",
  hscw: null,
  sex: null,
  category: null,
  fat_score: null,
  carcase_condemn: null,
  condemn_area: null,
  condemn_info: null,
  MSA: 0,
  HGP: null,
  production_date: null,
  process_time: null,
  scan_time: null,
  grade_time: null,
  chill_start_time: null,
  chill_stop_time: null,
  upload_time: null,
  invoice_no: null,
  PIC: "",
};
export const porcineObj = {
  transaction_id: "",
  body_number: 0,
  lot_no: 0,
  lot_size: 1,
  owner: "",
  origin: "",
  hscw: null,
  sex: null,
  category: null,
  trims: null,
  p2fat: null,
  carcase_condemn: null,
  condemn_area: null,
  condemn_info: null,
  MSA: 0,
  HGP: null,
  production_date: null,
  process_time: null,
  scan_time: null,
  grade_time: null,
  mob_no: null,
  chill_start_time: null,
  chill_stop_time: null,
  upload_time: null,
  invoice_no: null,
  PIC: "",
};
export const bovineDisplayObj = [
  { name: "Body No", value: "body_number" },
  { name: "Lot No", value: "lot_no" },
  { name: "Lot Size", value: "lot_size" },
  { name: "Owner", value: "owner" },
  { name: "Origin", value: "origin" },
  { name: "Hot Weight", value: "hscw" },
  { name: "Gender", value: "sex" },
  { name: "Category", value: "category" },
  { name: "Fat Score", value: "fat_depth" },
  { name: "MSA", value: "MSA" },
  { name: "HGP", value: "HGP" },
  { name: " Processing date", value: "production_date" },
];
export const ovineDisplayObj = [
  { name: "Body No", value: "body_number" },
  { name: "Mob No", value: "mob_no" },
  { name: "Lot No", value: "lot_no" },
  { name: "Lot Size", value: "lot_size" },
  { name: "Owner", value: "owner" },
  { name: "Origin", value: "origin" },
  { name: "Hot Weight", value: "hscw" },
  { name: "Gender", value: "sex" },
  { name: "Category", value: "category" },
  { name: "Fat Score", value: "fat_score" },
  { name: "MSA", value: "MSA" },
  { name: "HGP", value: "HGP" },
  { name: " Processing date", value: "production_date" },
];
export const porcineDisplayObj = [
  { name: "Body No", value: "body_number" },
  { name: "Mob No", value: "mob_no" },
  { name: "Lot No", value: "lot_no" },
  { name: "Lot Size", value: "lot_size" },
  { name: "Owner", value: "owner" },
  { name: "Origin", value: "origin" },
  { name: "Hot Weight", value: "hscw" },
  { name: "Gender", value: "sex" },
  { name: "Trims", value: "trims" },
  { name: "Category", value: "category" },
  { name: "Fat Score", value: "p2fat" },
  { name: "MSA", value: "MSA" },
  { name: " Processing date", value: "production_date" },
];

export const caprineDisplayObj = [
  { name: "Body No", value: "body_number" },
  { name: "Lot No", value: "lot_no" },
  { name: "Lot Size", value: "lot_size" },
  { name: "Owner", value: "owner" },
  { name: "Origin", value: "origin" },
  { name: "Hot Weight", value: "hscw" },
  { name: "Gender", value: "sex" },
  { name: "Category", value: "category" },
  { name: "Fat Score", value: "fat_score" },
  { name: " Processing date", value: "production_date" },
];

export const otherDisplayObj = [
  { name: "Body No", value: "body_number" },
  { name: "Lot No", value: "lot_no" },
  { name: "Lot Size", value: "lot_size" },
  { name: "Owner", value: "owner" },
  { name: "Origin", value: "origin" },
  { name: "Hot Weight", value: "hscw" },
  { name: "Gender", value: "sex" },
  { name: "Category", value: "category" },
  { name: "Fat Score", value: "fat_score" },
  { name: " Processing date", value: "production_date" },
];

export const offalObject = {
  transaction_id: "",
  customer: "",
  type: "",
  weight: "",
  production_date: null,
};
export const skinObject = {
  transaction_id: "",
  customer: "",
  weight: "",
  production_date: null,
};

export const matchSpecies = {
  Bovine: "beefs",
  Ovine: "lambs",
  Porcine: "pigs",
  Caprine: "goats",  
  Other: "others",   
};

export const CUSTOMER_REPORT_PDF = [
  { name: "Body No", value: "body_number" },
  { name: "Customer", value: "owner" },
  { name: "Origin", value: "origin" },
  { name: "Sex", value: "sex" },
  { name: "Category", value: "category" },
  { name: "HSCW", value: "hscw" },
  { name: "Fat Score", value: "fat_score" },
  { name: "Production Date", value: "production_date" },
  { name: "Species", value: "species" },
];

const KILL_REGISTER_COLUMNS = [
  { name: "Body No", value: "body_number" },
  { name: "RFID", value: "rfid_no" },
  { name: "NLIS_ID", value: "nlis_id" },
  { name: "PIC", value: "pic" },
  { name: "Customer", value: "owner" },
  { name: "Origin", value: "origin" },
  { name: "Production Date", value: "production_date" },
  { name: "Species", value: "species" },
];

export const NLIS_ENDPOINT = "https://kong-555c197b45auogc2d.kongcloud.dev";